import { btn } from "@/ui/btn.js";
import { eventEmitter } from "@/utils/event-emitter.js";
import { continueGame } from "@/core/continueGame";
import "@/styles/style.scss";
import "@/styles/components/level-bar.scss";

export function continueBtn(parent) {
  continueGame();
  const elem = btn({
    text: "Continue game",
    parent: parent,
    classes: ["continue", "btn", "controls-bar__item"],
    onClick: () => eventEmitter.emit("continueGame"),
  });
  return elem;
}
